import "./App.css";
import { useState, useEffect } from "react";
import Homepage from "./pages/Homepage/Homepage";
import SigninPages from "./pages/auth/Signin";
import SignupPages from "./pages/auth/SignUp";
import ProfilePage from "./pages/Profile/ProfilePages";
import SearchByLocation from "./pages/job/SearchByLocation";
import ApplyJob from "./pages/application/ApplyJob";
import SingleJob from "./pages/job/SingleJob";
import JobPage from "./pages/job/JobPage";
import EmployeePage from "./pages/Employer/EmployeePage";
import PostJob from "./pages/job/PostJob";
import EmployeeData from "./pages/employee/EmployeeData";
import Eja from "./pages/eja/Eja";
import EjaDetails from "./pages/eja/EjaDetails";
import JobFromEja from "./pages/job/JobFromEja";
import ApplicantList from "./pages/application/ApplicantList";
import TemplateCV from "./pages/cv/TemplateCV";
import Notification from "./pages/Notification";
import Quickjob from "./pages/job/Quickjob";
import ApplyForAllowance from "./pages/application/ApplyForAllowance";
import GuarantorForm from "./pages/GuarantorForm";
import Blog from "./pages/Blog";
import Benefit from "./pages/benefit/Benefit";
import Blacklist from "./pages/blacklist/Blacklist";
import AboutUs from "./pages/about/AboutUs";
import Privacy from "./pages/privacy/PrivacyPage";
import TermAndConditions from "./pages/TermAndConditions";
import Offer from "./pages/job/Offer";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ApplicantResponse from "./pages/application/ApplicantResponse";
import ApplicantionStatus from "./pages/application/ApplicationStatus";
import EmployeeProfile from "./pages/employee/EmployeeProfile";
import Dashboard from "./pages/admin/Dashboard";
import MakeOffer from "./pages/job/MakeOffer";
import SearchByCategory from "./pages/job/SearchByCategory";
import VerifyToken from "./pages/auth/VerifyToken";
import Company from "./pages/Company";
import NotFound from "./component/notFound/NotFound";
import Candidate from "./pages/candidate";
import InterviewPeer from "./pages/interview/InterviewPeer";
import NewPassword from "./pages/auth/NewPassword";
import ViewCandidate from "./pages/candidate/ViewCandidate";
import Admin from "./Admin/Admin";
import Login from "./Admin/Login";
import Register from "./Admin/Register";



import JuniorAdminLogin from "./adminCreatedBySuperAdmin/JuniorAdminLogin";
import JuniorAdminDashboard from "./adminCreatedBySuperAdmin/JuniorAdminDashboard";
import JobNotificationRegister from "./pages/Subscription/JobNotificationRegister";
import AdminAccountantLogin from "./adminCreatedBySuperAdmin/AdminAccountantLogin";
import AdminAccountant1 from "./adminCreatedBySuperAdmin/AdminAccountant1";
import AdminAccountant2 from "./adminCreatedBySuperAdmin/AdminAccountant2";
import PinModal from "./OOSH/PinModal";
import OOshDashboard from "./OOSH/Dashboard";
import SearchPosts from "./OOSH/sidebarItems/SearchForPosts";
import PostDetails from "./OOSH/sidebarItems/PostDetails";
function App() {
  const [showModal, setShowModal] = useState(!localStorage.getItem('ooshPin'));
   useEffect(() => {
    if (localStorage.getItem('ejobEmail') && !localStorage.getItem('ooshPin')) {
      setShowModal(true);
    }
  }, []);
  const router = createBrowserRouter([
   
    {
      path: "/",
      element: <Homepage />,
    },
    {
      path: "/profile/:id",
      element: <ProfilePage />,
    },
    {
      path: "/employer/:id",
      element: <EmployeePage />,
    },
    {
      path: "/jobs",
      element: <JobPage />,
    },
    {
      path: "/candidate",
      element: <Candidate />,
    },
    {
      path: "/advance_candidate",
      element: <ViewCandidate />,
    },
    {
      path: "/job/:jobId",
      element: <SingleJob />,
    },
    {
      path: "/:applicationId/applicationStatus",
      element: <ApplicantResponse />,
    },
    {
      path: "/:applicantId/applicantProfile/:jobId",
      element: <EmployeeProfile />,
    },
    {
      path: "/job/apply/:jobId",
      element: <ApplyJob />,
    },
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/aboutUs",
      element: <AboutUs />,
    },
    {
      path: "/company",
      element: <Company />,
    },
    {
      path: "/verifyToken",
      element: <VerifyToken />,
    },
    {
      path: "/interview/start/:interviewId",
      element: <InterviewPeer />,
    },
    {
      path: "/makeOffer/:employer/:candidate/:application/:index",
      element: <MakeOffer />,
    },
    {
      path: "/Offer/:offerId/:applicationId",
      element: <Offer />,
    },
    {
      path: "/:userId/quickJob",
      element: <Quickjob />,
    },
    // {
    //   path: "/chat",
    //   element: <ChatTwo />,
    // },
    {
      path: "/searchByLocation/:locationId",
      element: <SearchByLocation />,
    },
    {
      path: "/searchByCategory/:categoryName",
      element: <SearchByCategory />,
    },
    {
      path: "/:userId/postJob",
      element: <PostJob />,
    },
    {
      path: "/:jobId/employeeData/:employeeId",
      element: <EmployeeData />,
    },
    {
      path: "/eJA",
      element: <Eja />,
    },
    {
      path: "/:userID/applyforAllowance",
      element: <ApplyForAllowance />,
    },
    {
      path: "/:userID/guarantorForm",
      element: <GuarantorForm />,
    },
    {
      path: "/blacklist",
      element: <Blacklist />,
    },
    {
      path: "/blog",
      element: <Blog />,
    },
    {
      path: "/benefit",
      element: <Benefit />,
    },
    {
      path: "/:employerId/eJAmain",
      element: <EjaDetails />,
    },
    {
      path: "/jobFromEja/:userId",
      element: <JobFromEja />,
    },
    {
      path: "/:userId/notification",
      element: <Notification />,
    },
    {
      path: "/privacy",
      element: <Privacy />,
    },
    {
      path: "/terms",
      element: <TermAndConditions />,
    },
    {
      path: "/:jobId/jobApplicants",
      element: <ApplicantList />,
    },
    {
      path: "/:jobId/applicantResponse",
      element: <ApplicantionStatus />,
    },
    {
      path: "/:userId/createCV",
      element: <TemplateCV />,
    },
    {
      path: "/signin",
      element: <SigninPages />,
    },
    {
      path: "/signup",
      element: <SignupPages />,
    },
    {
      path: "/newPassword/:token/:userId",
      element: <NewPassword />,
    },
    {
      path: "/admindashboard",
      element: <Admin />,
    },
    {
      path: "/adminlogin",
      element: <Login />,
    },
    {
      path: "/adminsignup",
      element: <Register />,
    },
    {
      path: "/jadminlogin",
      element: <JuniorAdminLogin />,
    },
    {
      path: "/jadmindashboard",
      element: <JuniorAdminDashboard />,
    },
      {
      path: "/Aadminlogin",
      element: <AdminAccountantLogin />,
    },
      {
      path: "/accountant1",
      element: <AdminAccountant1 />,
    },
      {
      path: "/accountant2",
      element: <AdminAccountant2 />,
    },
  
    {
      path: "/jobnotification",
      element: <JobNotificationRegister />,
    },
 
  


    {
      path: "*",
      element: <NotFound />,
    },

       {
      path: "/oosh-dashboard",
      element: localStorage.getItem('ooshPin') ? <OOshDashboard /> : <PinModal />,
    },

    {
      path:"/ooshlogin",
      element:localStorage.getItem('email') ? <PinModal /> : <PinModal/> ,
    },

      {
      path: "/post/:postId",
      element: <PostDetails />,
    },






  ]);
  return (
    <>
   {/* {showModal && <PinModal onSubmit={() => setShowModal(false)} />} */}
  <RouterProvider router={router} />
  </>
  )
}

export default App;



///admin details---- email:essential01@gmail.com
///password: essential01


